module.exports = __webpack_public_path__ + "img/development_history.b9f21e9c.png";